export const STATUS_OPTIONS = [
  { value: "draft", label: "Borrador" },
  { value: "pending_sync", label: "Pendiente de sincronizar" },
  { value: "received", label: "Recibido" },
  { value: "limited_published", label: "Publicado limitado" },
  { value: "limited_published_pending_verification", label: "Publicado limitado (pend. verif.)" },
  { value: "pending_review", label: "Pendiente de revisión" },
  { value: "verified_published", label: "Publicado verificado" },
  { value: "possible_duplicate", label: "Posible duplicado" },
  { value: "contact_request_received", label: "Solicitud de contacto recibida" },
  { value: "reunification_in_progress", label: "En proceso de reunificación" },
  { value: "reunified", label: "Reunificado" },
  { value: "closed", label: "Cerrado" },
  { value: "privacy_removed", label: "Retirado por privacidad" },
  { value: "risk_blocked", label: "Bloqueado por riesgo" },
  { value: "rejected", label: "Rechazado" },
];
